/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  BooleanHelper,
  StorageKey,
  StorageManager,
  UrlHelper,
} from "@bms/common";
import { useEffect } from "react";

export const useFeatureFlags = () => {
  const { preview } = UrlHelper.parse(window.location.search);

  useEffect(() => {
    const setFeatureFlags = async () => {
      if (preview === null || preview === undefined) {
        return;
      }
      const previewMode = BooleanHelper.toBool(preview);
      await StorageManager.setValue(StorageKey.previewMode, previewMode);
    };

    setFeatureFlags();
  }, [preview]);
};
